module.exports = __webpack_public_path__ + "img/industri_med_paavirkningsgrad.22648ff6.jpg";